import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Toaster } from 'react-hot-toast';
import { PlatformAuthProvider } from './contexts/PlatformAuthContext';
import AppRoutes from './routes/AppRoutes';
import theme from './theme';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <PlatformAuthProvider>
          <AppRoutes />
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: 'var(--c-333333)',
                color: 'var(--c-ffffff)'
              },
              success: {
                style: {
                  background: 'var(--c-brand-dark)'
                }
              },
              error: {
                style: {
                  background: 'var(--c-d32f2f)'
                }
              }
            }}
          />
        </PlatformAuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
